export const shadows = [
  'none',
  '0px 2px 8px rgba(0, 0, 0, 0.16)',
  '0px 1px 4px rgba(0, 0, 0, 0.16)',
];
